var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.6528 10.0307C21.2628 9.47071 20.5728 9.15071 19.7828 9.15071H15.6828C15.4128 9.15071 15.1628 9.04071 14.9928 8.84071C14.8128 8.64071 14.7428 8.36071 14.7828 8.07071L15.2928 4.79071C15.5128 3.81071 14.8628 2.71071 13.8828 2.38071C12.9728 2.04071 11.9028 2.50071 11.4728 3.15071L7.25281 9.42071L7.13281 9.62071V18.4607L7.28281 18.6107L10.4528 21.0607C10.8728 21.4807 11.8228 21.7107 12.4928 21.7107H16.3928C17.7328 21.7107 19.0828 20.7007 19.3828 19.4707L21.8428 11.9807C22.1028 11.2707 22.0328 10.5807 21.6528 10.0307Z",
    fill: "#146729"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21 6.38086H4.18C2.63 6.38086 2 6.98086 2 8.46086V18.5209C2 20.0009 2.63 20.6009 4.18 20.6009H5.21C6.76 20.6009 7.39 20.0009 7.39 18.5209V8.46086C7.39 6.98086 6.76 6.38086 5.21 6.38086Z",
    fill: "#146729"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/ThumbUp.c9d76a4a287e8de6fa39c83667878e4f.svg";
export { ForwardRef as ReactComponent };